module.exports = __webpack_public_path__ + "img/book.83aabf88.png";